import React from "react";
var __jsx = React.createElement;
/**
 * Then block for Conditional component
 */
export var Then = function Then(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};